import React from "react";
import { useSortableContext } from "@admin/components/Sortable/SortableContext";

type Props = {
    top?: number;
    right?: number;
};

export default function SortingButton({ top, right }: Props) {
    const { setIsActive } = useSortableContext();

    return (
        <i
            className="fa fa-sort position-absolute cursor-pointer"
            style={{ top: top ? `${top}rem` : `2rem`, right: right ? `${right}rem` : `3rem`, fontSize: `1.5rem` }}
            title="Сортировать блок по методу Drag-and-drop"
            onMouseEnter={() => setIsActive(true)}
            onMouseLeave={() => setIsActive(false)}
        ></i>
    );
}
